import React, { useEffect, useState } from 'react';
import './BlogSection.scss';

const BLOG_URL = process.env.REACT_APP_BLOG_URL || 'https://blog.77gestao.com.br';
const POSTS_JSON_URL = `${BLOG_URL}/posts.json`;

interface BlogPost {
  slug: string;
  title: string;
  date: string;
  description: string;
  category: string;
  categoryLabel: string;
  image: string;
  readingTime: number;
}

function formatDate(dateStr: string): string {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

const BlogSection: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(POSTS_JSON_URL)
      .then((r) => r.json())
      .then((data: BlogPost[]) => setPosts(data.slice(0, 3)))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading || posts.length === 0) return null;

  return (
    <section className="blog-section" id="blog">
      <div className="blog-section__container">
        <div className="blog-section__header">
          <div className="blog-section__label">Conteúdo gratuito</div>
          <h2 className="blog-section__title">
            Últimos artigos do <span className="blog-section__highlight">blog</span>
          </h2>
          <p className="blog-section__subtitle">
            Dicas práticas de gestão, finanças e automação para o seu negócio.
          </p>
        </div>

        <div className="blog-section__grid">
          {posts.map((post) => (
            <a
              key={post.slug}
              href={`${BLOG_URL}/post/${post.slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-card"
            >
              {post.image && (
                <div className="blog-card__image-wrapper">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="blog-card__image"
                    loading="lazy"
                  />
                </div>
              )}
              <div className="blog-card__body">
                <div className="blog-card__meta">
                  <span className="blog-card__category">{post.categoryLabel}</span>
                  <span className="blog-card__reading-time">{post.readingTime} min</span>
                </div>
                <h3 className="blog-card__title">{post.title}</h3>
                <p className="blog-card__excerpt">{post.description}</p>
                <p className="blog-card__date">{formatDate(post.date)}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="blog-section__cta">
          <a
            href={BLOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="blog-section__cta-btn"
          >
            Ver todos os artigos →
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
